
const config = {
  /**服务主域名 */
  serverUrl: 'https://klk.api.mgtv.com',
  /**跳转播放url */
  videoPlayUrl: 'https://hnedu.mgtv.com',
};

const getConfig = () => config;

export default getConfig;



//////////////////
// WEBPACK FOOTER
// ./config/dispose.js
// module id = null
// module chunks = 